module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("To show a data table is very simple, you just need a "), _c('code', [_vm._v("data")]), _vm._v(" and a "), _c('code', [_vm._v("columns")]), _vm._v(" prop.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSandbox,
      "code": _vm.ExSandboxCode,
      "title": "Sandbox with custom template"
    }
  }, [_c('p', [_vm._v("To show a custom row template, you "), _c('b', [_vm._v("should not use the "), _c('code', [_vm._v("columns")]), _vm._v(" prop")]), _vm._v(", but add it within the scoped slot as a component.")]), _vm._v(" "), _c('p', [_vm._v("Also you can add an "), _c('code', [_vm._v("empty")]), _vm._v(" named slot to show when there's no data.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSelection,
      "code": _vm.ExSelectionCode,
      "title": "Selection"
    }
  }, [_c('p', [_vm._v("\n                You can show a "), _c('strong', [_vm._v("single selected")]), _vm._v(" row by passing the corresponding object to the "), _c('code', [_vm._v("selected")]), _vm._v(" prop.\n                Additionally, adding the "), _c('code', [_vm._v(".sync")]), _vm._v(" modifier will make it two-way binding — selected object will mutate if user clicks on row.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Use "), _c('code', [_vm._v("focusable")]), _vm._v(" prop make table to be focused and navigable with a keyboard using "), _c('strong', [_vm._v("arrow keys")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCheckable,
      "code": _vm.ExCheckableCode,
      "title": "Checkable"
    }
  }, [_c('p', [_vm._v("You can add checkboxes to rows by using the "), _c('code', [_vm._v("checkable")]), _vm._v(" prop.")]), _vm._v(" "), _c('p', [_vm._v("\n                To show which rows are "), _c('strong', [_vm._v("checked")]), _vm._v(", you have to pass the corresponding object array to the "), _c('code', [_vm._v("checked-rows")]), _vm._v(" prop.\n                Adding the "), _c('code', [_vm._v(".sync")]), _vm._v(" modifier will make it two-way binding — checked object array will mutate if user clicks on checkboxes.\n            ")]), _vm._v(" "), _c('p', [_vm._v("A slot called "), _c('code', [_vm._v("bottom-left")]), _vm._v(" is available whenever the table is checkable or paginated, you can add anything in there.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSearchable,
      "code": _vm.ExSearchableCode,
      "title": "Searchable"
    }
  }, [_c('p', [_vm._v("You can add search filtering to rows by using the "), _c('code', [_vm._v("searchable")]), _vm._v(" prop.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                This feature is not available on mobile when "), _c('code', [_vm._v("mobile-card")]), _vm._v(".\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPaginationSort,
      "code": _vm.ExPaginationSortCode,
      "title": "Pagination and sorting"
    }
  }, [_c('p', [_vm._v("To make a column sortable, add the "), _c('code', [_vm._v("sortable")]), _vm._v(" prop on it and specify a "), _c('code', [_vm._v("field")]), _vm._v(" name.")]), _vm._v(" "), _c('p', [_vm._v("You can also use the "), _c('code', [_vm._v("default-sort")]), _vm._v(" prop to determine the default sort column and order. The column must be "), _c('code', [_vm._v("sortable")]), _vm._v(" to work.")]), _vm._v(" "), _c('p', [_vm._v("The "), _c('code', [_vm._v("default-sort-direction")]), _vm._v(" prop can be set to determine the default sort column direction on the first click.")]), _vm._v(" "), _c('p', [_vm._v("A slot called "), _c('code', [_vm._v("bottom-left")]), _vm._v(" is available whenever the table is checkable or paginated, you can add anything in there.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExDetailedRow,
      "code": _vm.ExDetailedRowCode,
      "title": "Detailed rows"
    }
  }, [_c('p', [_vm._v("You can have detailed rows by adding a "), _c('code', [_vm._v("detail")]), _vm._v(" named scoped slot and the "), _c('code', [_vm._v("detailed")]), _vm._v(" prop.")]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.2")])]), _vm._v(" "), _c('p', [_vm._v(" You can also toggle row detail programmatically using "), _c('code', [_vm._v("toggleDetails")]), _vm._v(" method and "), _c('code', [_vm._v(":show-detail-icon=\"false\"")]), _vm._v(" if you want to hide chevron icon.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomDetailedRow,
      "code": _vm.ExCustomDetailedRowCode,
      "title": "Custom Detailed rows"
    }
  }, [_c('p', [_vm._v("You can add anything you like into the "), _c('code', [_vm._v("detail")]), _vm._v(" named scoped by providing the "), _c('code', [_vm._v("customDetailRow")]), _vm._v(" prop to the table.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                Be cautious when using a custom detailed row and toggling the display of columns,\n                as you will have to manage either the content within (with "), _c('code', [_vm._v("colspan")]), _vm._v(") or the columns themselves dependent on the content displayed.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExRowStatus,
      "code": _vm.ExRowStatusCode,
      "title": "Row status"
    }
  }, [_c('p', [_vm._v("Use the "), _c('code', [_vm._v("row-class")]), _vm._v(" prop to return a class name. It's a function that receives "), _c('code', [_vm._v("row")]), _vm._v(" and "), _c('code', [_vm._v("index")]), _vm._v(" parameters.")]), _vm._v(" "), _c('p', [_vm._v("Note that "), _c('strong', [_vm._v("you have to style the class yourself")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomHeaders,
      "code": _vm.ExCustomHeadersCode,
      "title": "Custom headers"
    }
  }, [_c('p', [_vm._v("\n                By adding a scoped slot named "), _c('code', [_vm._v("header")]), _vm._v(" in table component you can customize the headers.\n                Use the "), _c('code', [_vm._v("meta")]), _vm._v(" prop on column to pass anything you may need.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Previous scoped slot named "), _c('code', [_vm._v("header")]), _vm._v(" in table will be deprecated.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSubheadings,
      "code": _vm.ExSubheadingsCode,
      "title": "Subheadings"
    }
  }, [_c('p', [_vm._v("\n                Use the "), _c('code', [_vm._v("subheading")]), _vm._v(" prop on columns to add subheadings. This is particularly useful to display a summary when dealing with long tables.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                By adding a scoped slot named "), _c('code', [_vm._v("subheading")]), _vm._v(" in table component you can customize the subheadings.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExToggleColumns,
      "code": _vm.ExToggleColumnsCode,
      "title": "Toggle columns"
    }
  }, [_c('b-message', {
    attrs: {
      "type": "is-danger"
    }
  }, [_vm._v("\n                Always use the "), _c('code', [_vm._v("visible")]), _vm._v(" prop to hide/show columns, and "), _c('strong', [_vm._v("NOT")]), _vm._v(" "), _c('code', [_vm._v("v-if")]), _vm._v(" or "), _c('code', [_vm._v("v-show")]), _vm._v(".\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFooter,
      "code": _vm.ExFooterCode,
      "title": "Footer"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAsyncData,
      "code": _vm.ExAsyncDataCode,
      "title": "Async data"
    }
  }, [_c('p', [_vm._v("\n                Use "), _c('code', [_vm._v("backend-sorting")]), _vm._v(" and "), _c('code', [_vm._v("backend-pagination")]), _vm._v(" props to let those tasks to the backend,\n                then manage it with "), _c('code', [_vm._v("page-change")]), _vm._v(" and "), _c('code', [_vm._v("sort")]), _vm._v(" events.\n            ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")]), _vm._v(".")])])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExDraggableRows,
      "code": _vm.ExDraggableRowsCode,
      "title": "Draggable rows"
    }
  }, [_c('p', [_vm._v("\n                Use "), _c('code', [_vm._v("draggable")]), _vm._v(" prop to allow rows to be draggable. Manage dragging using "), _c('code', [_vm._v("dragstart")]), _vm._v(",\n                "), _c('code', [_vm._v("dragover")]), _vm._v(" and "), _c('code', [_vm._v("drop")]), _vm._v(" events\n            ")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403b324b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/Table.vue
// module id = 1527
// module chunks = 1